import * as React from "react";
import PropTypes from 'prop-types';

const SvgDotVideoActive = props => {
  if (props.id !== "_svgdotvideoactive") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 8 8" fill="none" {...props}><path d="M.421.095a.93.93 0 01.838.007L7.59 3.375a.787.787 0 01.3.265c.071.11.109.234.109.36 0 .126-.038.25-.11.36a.786.786 0 01-.298.265L1.259 7.898a.93.93 0 01-.838.006.79.79 0 01-.308-.266A.657.657 0 010 7.273V.727C0 .6.039.473.113.362A.79.79 0 01.421.095z" fill="#666" /></svg>;
};

SvgDotVideoActive.displayName = "_svgdotvideoactive";
SvgDotVideoActive.propTypes = {
  id: PropTypes.string
};
SvgDotVideoActive.defaultProps = {
  id: ''
};
export default SvgDotVideoActive;